import { Account, AccountType } from '@mews-commander/data-access';
import { RouteName } from '@mews-commander/enums';
import { RouteLink, RouteLinkProps } from '@mews-commander/ui';
import { AccountName } from './AccountName';

interface AccountLinkProps extends Omit<RouteLinkProps, 'route' | 'params'> {
    account: Account;
}

export const AccountLink = ({ account, ...other }: AccountLinkProps) => (
    <RouteLink {...other} {...getRouteProps(account)}>
        <AccountName account={account} />
    </RouteLink>
);

const getRouteProps = (account: Account) => {
    if (account.data.discriminator === AccountType.Customer) {
        return { route: RouteName.CustomerDetail, params: { id: account.id } };
    }

    return { route: RouteName.CompanyDetail, params: { id: account.id } };
};
